/**
 * Routes for the System Config domain
 */
export const routes = {
  systemConfig: {
    root: '/system-config',
    labelManagement: '/system-config/label-management',
  },
};
